/**
 * @file 判断域名是否是外部链接
 * @author wangqianghong
 */

/**
 * 判断链接是否为外部链接
 *
 * @param {string} domain 链接的域名
 * @return {boolean} 是否是外部链接
 */

// 合法域名白名单
const validDomainReg = /^(?:(?:.+\.)?baidu.com|(?:www\.)?wenjuan.com)$/i;

const isExternalLink = domain => {
    return !validDomainReg.test(domain);
};

export default isExternalLink;
